/* Prestige Pre-Order page: WhatsApp links, grid filter, hero slider. */
(function () {
  if (window.__ppPreorder) return;
  window.__ppPreorder = true;

  function grid() { return document.querySelector('[data-pp-grid]'); }

  function waUrl(msg) {
    var g = grid();
    var num = ((g && g.dataset.wa) || '').replace(/\D/g, '');
    return 'https://wa.me/' + num + '?text=' + encodeURIComponent(msg);
  }

  function buildLinks() {
    var g = grid();
    if (!g) return;
    document.querySelectorAll('.pp [data-pp-product]').forEach(function (c) {
      var lines = [g.dataset.intro || 'Hi, I would like to pre-order this product:'];
      lines.push('Product: ' + c.dataset.name);
      if (c.dataset.variant) lines.push('Option: ' + c.dataset.variant);
      if (c.dataset.sku) lines.push('SKU: ' + c.dataset.sku);
      if (g.dataset.showPrice === 'true' && c.dataset.price) lines.push('Price: ' + c.dataset.price);
      c.href = waUrl(lines.join('\n'));
      c.target = '_blank';
      c.rel = 'noopener';
    });
    document.querySelectorAll('.pp .js-pp-wa').forEach(function (a) {
      a.href = waUrl(g.dataset.general || 'Hi, I would like to know more about your pre-order collection.');
      a.target = '_blank';
      a.rel = 'noopener';
    });
  }

  function filter(f) {
    var g = grid();
    if (!g) return;
    f = (f || 'all').toLowerCase();
    var known = false;
    g.querySelectorAll('[data-pp-tab]').forEach(function (t) {
      var on = t.dataset.f === f;
      if (on) known = true;
      t.classList.toggle('on', on);
    });
    if (!known) {
      var all = g.querySelector('[data-pp-tab][data-f="all"]');
      if (all && f === 'all') all.classList.add('on');
    }
    g.querySelectorAll('[data-pp-product]').forEach(function (c) {
      var tags = (c.dataset.cat || '').split(' ');
      c.style.display = (f === 'all' || tags.indexOf(f) > -1) ? '' : 'none';
    });
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.pp [data-pp-tab]');
    if (tab) { filter(tab.dataset.f); return; }
    var go = e.target.closest('.pp [data-go]');
    if (go) {
      e.preventDefault();
      filter(go.dataset.go);
      var g = grid();
      if (g) g.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  function initHero(hero) {
    if (hero.__ppInit) return;
    hero.__ppInit = true;
    var slides = hero.querySelectorAll('.slide');
    var dots = hero.querySelectorAll('.sl-dot');
    if (slides.length < 2) return;
    var cur = 0, timer, delay = (parseInt(hero.dataset.speed, 10) || 5) * 1000;
    function goTo(n) {
      slides[cur].classList.remove('active'); if (dots[cur]) dots[cur].classList.remove('on');
      cur = (n + slides.length) % slides.length;
      slides[cur].classList.add('active'); if (dots[cur]) dots[cur].classList.add('on');
    }
    function auto() { clearInterval(timer); if (hero.dataset.autoplay === 'true') timer = setInterval(function () { goTo(cur + 1); }, delay); }
    var next = hero.querySelector('.sl-next'), prev = hero.querySelector('.sl-prev');
    if (next) next.addEventListener('click', function () { goTo(cur + 1); auto(); });
    if (prev) prev.addEventListener('click', function () { goTo(cur - 1); auto(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { goTo(+d.dataset.i); auto(); }); });
    var tx = 0;
    hero.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      var diff = tx - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) { goTo(diff > 0 ? cur + 1 : cur - 1); auto(); }
    });
    /* theme editor: jump to the slide being edited */
    hero.addEventListener('shopify:block:select', function (e) {
      var i = Array.prototype.indexOf.call(slides, e.target);
      if (i > -1) { clearInterval(timer); goTo(i); }
    });
    auto();
  }

  function init() {
    document.querySelectorAll('.pp [data-pp-hero]').forEach(initHero);
    buildLinks();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
